/* eslint-disable quotes */
const basepaths = {
    dev: 'https://api.scisapp.com.dev.fortalsistemas.com.br/v1/dev',
    alpha: 'https://api.scisapp.com.staging.fortalsistemas.com.br/v1/alpha',
    beta: '',
    prod: 'https://api.scisapp.com/v1/prod',
};

const url = basepaths[process.env.REACT_APP_STAGE || 'dev'];

const basepathsOnlineTests = {
    dev: 'https://dev.api.scisapp.com.dev.fortalsistemas.com.br/v2/ead',
    alpha: 'https://alpha.api.scisapp.com.staging.fortalsistemas.com.br/v2/ead',
    beta: '',
    prod: 'https://prod.api.scisapp.com/v2/ead',
};

const urlOnlineTests =
    basepathsOnlineTests[process.env.REACT_APP_STAGE || 'dev'];

const authUrls = {
    dev: 'https://dev.login.scisapp.com/v2/oauth2',
    alpha:
        'https://login.febracis.com.br.staging.fortalsistemas.com.br/v2/oauth2',
    beta: '',
    prod: 'https://login.febracis.com.br/v2/oauth2',
};

export const urlAuth = authUrls[process.env.REACT_APP_STAGE || 'dev'];

export const urls = {
    LOGIN: urlAuth + '/token',
    LOGOUT: urlAuth + '/logout',
    GET_USER_INFO: url + '/profiles/me',
    CLASSES: id => `${url}/ead-classes/classes${id ? `/${id}` : ''}`,
    COURSES: id => `${url}/ead-classes/courses${id ? `/${id}` : ''}`,
    TCCS: `${url}/ead-enrollments/tccs`,
    TCC_FILE: `${url}/ead-enrollments/tccs/file`,
    FILE_UPLOAD: `${url}/upload`,
    REQUEST_URL_TO_ATTACHMENT: (UserId, classId, contentType, filename) =>
        `${url}/ead-enrollments/attachments/upload?userId=${UserId}&classId=${classId}&contentType=${contentType}&fileName=${filename}`,
    REQUEST_ATTACH_LIST: (userId, classId) =>
        `${url}/ead-enrollments/enrollments/attachments?userId=${userId}&classId=${classId}`,
    DOWNLOAD_ATTACHMENT: (userId, classId, attachId) =>
        `${url}/ead-enrollments/attachments/download?fileId=${attachId}&userId=${userId}&classId=${classId}`,
    REMOVE_ATTACHMENT: (userId, classId, attachId) =>
        `${url}/ead-enrollments/enrollments/attachments?fileId=${attachId}&userId=${userId}&classId=${classId}`,
    TRAINERS: `${url}/ead-enrollments/users/trainers`,
    TRACKED: `${url}/ead-enrollments/users/tracked`,
    USERS: `${url}/ead-enrollments/users/coaches`,
    USER: id => `${url}/ead-enrollments/users/${id}`,
    CENTERS: `${url}/ead-enrollments/centers`,
    ENROLLMENTS: `${url}/ead-enrollments/enrollments`,
    ADMINS: `${url}/ead-enrollments/users/admins`,
    ADD_NEW_USER: userId =>
        `${url}/ead-enrollments/users${userId ? `/${userId}` : ''}`,
    TEMPLATE_QUESTIONS: `${urlOnlineTests}/admin/template_questions`,
    TEMPLATE_QUESTION: ({ questionId }) =>
        `${urlOnlineTests}/admin/template_questions/${questionId}`,
    DUPLICATE_TEMPLATE_QUESTION: ({ questionId }) =>
        `${urlOnlineTests}/admin/template_questions/${questionId}/duplicate`,
    TEMPLATE_TESTS: `${urlOnlineTests}/admin/template_tests`,
    TEMPLATE_TEST: ({ testId }) =>
        `${urlOnlineTests}/admin/template_tests/${testId}`,
    DUPLICATE_TEMPLATE_TEST: ({ testId }) =>
        `${urlOnlineTests}/admin/template_tests/${testId}/duplicate`,
    BULK_TEMPLATE_TEST: ({ testId }) =>
        `${urlOnlineTests}/admin/template_tests/${testId}/template_questions/bulk`,
    QUESTIONS_TEMPLATE_TEST: ({ testId }) =>
        `${urlOnlineTests}/admin/template_tests/${testId}/template_questions`,
    PERFORMED_TESTS: `${urlOnlineTests}/admin/performed_tests`,
    PERFORMED_TESTS_EXPORT: `${urlOnlineTests}/admin/performed_tests/export`,
    TEST_TYPES: `${urlOnlineTests}/test_types`,
    COURSES_TEMPLATE_TESTS: courseId =>
        `${urlOnlineTests}/admin/courses/${courseId}/template_tests`,
    CLASSES_TEMPLATE_TESTS: classId =>
        `${urlOnlineTests}/admin/classes/${classId}/template_tests`,
    EAD_USER: `${urlAuth}/realms/ead`,
    APPROVE_TEST: (testId) => `${urlOnlineTests}/admin/performed_tests/${testId}/approve`,
    CORRECTION_TEST: (testId) => `${urlOnlineTests}/admin/performed_tests/${testId}/correction`,
    DISCARD_TEST: (testId) => `${urlOnlineTests}/admin/performed_tests/${testId}`,
};

const clientIds = {
    dev: '8Gjr7vy45NAFTa3e',
    alpha: '5jpXqpjg93c7ceS9',
    beta: '',
    prod: 'gMbPac6RWTwG3ZsL',
};

export const general = {
    client_id: clientIds[process.env.REACT_APP_STAGE || 'dev'],
};

export const mode = {
    isRelease: process.env.NODE_ENV === 'production',
};



// WEBPACK FOOTER //
// ./src/settings.js